import React from 'react';

const CtkViewer = ({ content }) => {
  const isHTML = /<\/?[a-z][\s\S]*>/i.test(content?.trim());

  return isHTML ? (
    <div
      style={{ width: '100%' }}
      dangerouslySetInnerHTML={{ __html: content }}
      contentEditable={false}
    />
  ) : (
    <div style={{ width: '100%', whiteSpace: 'pre-wrap' }}>{content}</div>
  );
};

export default CtkViewer;
